import { useRef } from 'react';

export const useUploadSelect = () => {
  const ref = useRef<HTMLInputElement>(null);
  const uploadSelect = (uploadFolders = false) => {
    if (!ref.current) return;

    if (uploadFolders) {
      ref.current.setAttribute('webkitdirectory', 'true');
    } else {
      ref.current.removeAttribute('webkitdirectory');
    }
    // eslint-disable-next-line no-param-reassign
    ref.current.value = '';
    ref.current?.click();
  };

  return {
    inputOpenFileRef: ref,
    uploadSelect,
  };
};
